import * as friendListsMutations from "@/store/modules/friendLists/mutation-types";
import * as customersMutations from "@/store/modules/customers/mutation-types";
import * as helpers from "./helpers";

export function onCurrentUserReset(store) {
  helpers.dispatchCustomers(store, "resetCustomer");
  helpers.dispatchCart(store, "reset");
  helpers.dispatchCart(store, "getCart");
}

export async function onCurrentCustomerSet(store, payload) {
  if (!payload) {
    return;
  }

  helpers.commitFriendLists(
    store,
    friendListsMutations.SET_MY_FRIEND_LIST_ID,
    payload.friendListId
  );
  helpers.commitFriendLists(
    store,
    friendListsMutations.SET_INVITED_FRIEND_LIST_ID,
    payload.invitedFriendListId
  );
  helpers.dispatchTickets(store, "getTickets", payload.id);
  helpers.dispatchCustomers(store, "getCustomers");
}

export function onCurrentCustomerReset(store) {
  helpers.commitCustomers(store, customersMutations.RESET_CUSTOMERS);
  helpers.commitFriendLists(
    store,
    friendListsMutations.RESET_MY_FRIEND_LIST_ID
  );
  helpers.commitFriendLists(
    store,
    friendListsMutations.RESET_INVITED_FRIEND_LIST_ID
  );
}
